// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2m1Gp","footer":"styles_footer__38D-K","passCodeTooltip":"styles_passCodeTooltip__jCYxR"};